import { Helmet } from "react-helmet-async"
import { ReactComponent as IconArrowLeft } from "../../../../assets/img/workshops/arrow-left.svg"
import { ReactComponent as IconCheck } from "../../../../assets/img/workshops/checkmark.svg"
import { ReactComponent as IconChevronDown } from "../../../../assets/img/workshops/chevron-down.svg"
import { ReactComponent as IconDevices } from "../../../../assets/img/workshops/devices.svg"
import { ReactComponent as IconFile } from "../../../../assets/img/workshops/file.svg"
import { ReactComponent as IconOnline } from "../../../../assets/img/workshops/online.svg"
import { ReactComponent as IconWifi } from "../../../../assets/img/workshops/wifi.svg"

import ImageDunia from "../../../../assets/img/workshops/image-dunia.png"
import { Link } from "react-router-dom"

import "./detail.css"

const RelationsPage = () => {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href={`${process.env.REACT_APP_FRONT_URL}/productos/taller-relacion-de-pareja-sana`}
        />
        <title>Taller Relaciones de Pareja | Conecta desde la consciencia</title>
        <meta
          name="description"
          content="Aprende a mirar tu relación de pareja con otra perspectiva. Descubre cómo fortalecer la conexión y cuidar el vínculo con herramientas prácticas."
        />
        <meta
          name="keywords"
          content="relaciones de pareja, comunicación emocional, bienestar emocional, crecimiento personal, psicología, autocuidado, Vikika Team, conexión pareja"
        />
        <meta
          property="og:title"
          content="Taller Relaciones de Pareja | Conecta desde la consciencia"
        />
        <meta
          property="og:description"
          content="Aprende a mirar tu relación de pareja con otra perspectiva. Descubre cómo fortalecer la conexión y cuidar el vínculo con herramientas prácticas."
        />
        <meta
          property="og:url"
          content={`${process.env.REACT_APP_FRONT_URL}/productos/taller-relacion-de-pareja-sana`}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content={`${process.env.REACT_APP_FRONT_URL}/img/workshops/relacion.png`}
        />
      </Helmet>

      <main className="main-content">
        <div className="workshops-page">
          <header
            className="workshops-detail-hero"
            style={{ backgroundColor: "var(--color-secondary-1-light)" }}
          >
            <div className="workshops-detail-hero-content">
              <div className="workshops-chip">
                <IconOnline />
                <p>Online</p>
              </div>
              <h1 className="workshops-detail-hero-title">Construir una relación de pareja sana</h1>
              <p className="workshops-detail-hero-description">
                En este taller, te invitamos a descubrir cómo cuidar de tu relación de pareja,
                aprendiendo a identificar los pilares que fortalecen tu relación, a comprender mejor
                a tu pareja y a ti mism@, y a cultivar una conexión más profunda y significativa. Te
                acompañaremos en un viaje de reflexión y practica para que tu relación crezca
                fuerte, resistente y llena de sentido.
              </p>
              <div className="workshops-detail-hero-footer">
                <div className="workshops-detail-hero-info">
                  <div className="workshops-detail-hero-info-data">
                    <p className="label">Duración</p>
                    <p className="value">2 horas</p>
                  </div>
                  <div className="workshops-detail-hero-info-data">
                    <p className="label">Impartido por</p>
                    <p className="value">Dunia</p>
                  </div>
                  <div className="workshops-detail-hero-info-data">
                    <p className="label">Precio</p>
                    <p className="value">29,99€</p>
                  </div>
                </div>
                <a
                  href="https://vikika-team-s-school.teachable.com/l/pdp/construir-una-sana-relacion-de-pareja"
                  className="workshops-btn workshops-btn-orange"
                >
                  Me apunto <IconArrowLeft className="workshops-btn-icon" />
                </a>
              </div>
            </div>
          </header>
          {/* Guía */}
          <section className="workshops-section workshops-guide">
            <h2 className="workshops-section-title">¿Qué aprenderás?</h2>
            <div className="workshops-guide-content">
              <details className="workshops-guide-step" name="guide-steps">
                <summary className="workshops-guide-step-launcher">
                  <span className="workshops-guide-number">1</span>
                  Conócete para conocer a tu pareja
                  <IconChevronDown />
                </summary>
                <p>
                  Descubre cómo el autoconocimiento es clave para valorar y comprender mejor a tu
                  pareja.
                </p>
              </details>
              <details className="workshops-guide-step" name="guide-steps">
                <summary className="workshops-guide-step-launcher">
                  <span className="workshops-guide-number">2</span>
                  Sentirse afortunado
                  <IconChevronDown />
                </summary>
                <p>
                  Aprende a cultivar la gratitud y la admiración para fortalecer el vínculo
                  afectivo.
                </p>
              </details>
              <details className="workshops-guide-step" name="guide-steps">
                <summary className="workshops-guide-step-launcher">
                  <span className="workshops-guide-number">3</span>
                  Vencer a los enemigos de la pareja
                  <IconChevronDown />
                </summary>
                <p>
                  Identifica y gestiona los factores internos y externos que ponen en riesgo la
                  relación.
                </p>
              </details>
              <details className="workshops-guide-step" name="guide-steps">
                <summary className="workshops-guide-step-launcher">
                  <span className="workshops-guide-number">4</span>
                  Construir vuestra microcultura
                  <IconChevronDown />
                </summary>
                <p>
                  Diseña rituales, costumbres y un sentido compartido que os una más allá de las
                  diferencias.
                </p>
              </details>
              <details className="workshops-guide-step" name="guide-steps">
                <summary className="workshops-guide-step-launcher">
                  <span className="workshops-guide-number">5</span>
                  Mantener el sentido de la relación
                  <IconChevronDown />
                </summary>
                <p>
                  Descubre el ‘para qué’ de vuestra relación y cómo mantener vivo su propósito con
                  el paso del tiempo.
                </p>
              </details>
            </div>
          </section>
          {/* Para ti */}
          <section className="workshops-section workshops-for-you">
            <h2 className="workshops-section-title">Estos talleres son para ti si…</h2>

            <div className="workshops-grid">
              <div className="workshops-card-simple">
                <IconCheck />
                <p>
                  <strong>Quieres fortalecer</strong> la conexión emocional con tu pareja y
                  disfrutar de una relación más plena.
                </p>
              </div>
              <div className="workshops-card-simple">
                <IconCheck />
                <p>
                  <strong>Buscas herramientas prácticas</strong> para comunicarte mejor y resolver
                  conflictos de manera constructiva.
                </p>
              </div>
              <div className="workshops-card-simple">
                <IconCheck />
                <p>
                  <strong>Deseas aprender a superar</strong> creencias limitantes, miedos e
                  inseguridades que afectan a tu relación.
                </p>
              </div>
              <div className="workshops-card-simple">
                <IconCheck />
                <p>
                  <strong>Te interesa recuperar</strong> la admiración y la complicidad en tu vida
                  en pareja.
                </p>
              </div>
              <div className="workshops-card-simple">
                <IconCheck />
                <p>
                  <strong>Quieres construir una relación sólida,</strong> consciente y con
                  propósito.
                </p>
              </div>
            </div>

            <div className="workshops-section-action">
              <a
                className="workshops-btn workshops-btn-primary"
                href="https://vikika-team-s-school.teachable.com/l/pdp/construir-una-sana-relacion-de-pareja"
              >
                Me apunto <IconArrowLeft className="workshops-btn-icon" />
              </a>
            </div>
          </section>
          {/* Necesito */}
          <section className="workshops-section workshops-requirements">
            <h2 className="workshops-section-title">¿Qué necesito?</h2>
            <div className="workshops-requirements-content">
              <div className="workshops-requirements-item">
                <IconDevices />
                <p>
                  <strong>Ordenador o dispositivo móvil</strong>
                </p>
              </div>
              <div className="workshops-requirements-item">
                <IconWifi />
                <p>
                  <strong>Conexión a internet</strong>
                </p>
              </div>
              <div className="workshops-requirements-item">
                <IconFile />
                <p>
                  <strong>Ordenador o Lápiz y papel</strong> o un dispositivo donde puedas apuntar
                  tus notas
                </p>
              </div>
            </div>
          </section>
          <section className="workshops-section workshops-experts">
            <h2 className="workshops-section-title">Nuestros profesionales</h2>
            <p className="workshops-section-description">
              Este curso está guiado por nutricionistas especializados en ayuno intermitente y salud
              hormonal, que combinan la evidencia científica con la experiencia práctica en
              consulta. Te acompañarán con un enfoque cercano, adaptado a ti y a tus necesidades,
              para que el ayuno sea una herramienta de bienestar y no una carga
            </p>
            <article className="workshops-experts-card">
              <img className="workshops-experts-card-image" src={ImageDunia} alt="Dunia Drexler" />
              <div className="workshops-experts-card-content">
                <h3 className="workshops-experts-card-title">Dunia Drexler</h3>
                <p className="workshops-experts-card-subtitle">
                  Graduada en Psicología por la Universidad Francisco de Vitoria y con Máster de
                  Psicología General Sanitaria en la Universidad San Pablo CEU.
                </p>
                <div className="workshops-experts-card-description">
                  <p>
                    Además, su continua formación la ha llevado a especializarse en inteligencia
                    emocional, terapia emocional sistémica con adultos, pareja y familia, así como
                    en violencia de género entre otros.
                  </p>
                  <p>
                    Su visión sobre la psicología y el ser humano es holística, por lo que le gusta
                    aplicar la corriente emocional sistémica en sus sesiones, ya que considera a la
                    persona dentro de un contexto y siempre teniendo en cuenta que la psicoterapia
                    debe adaptarse a las necesidades individuales.
                  </p>
                </div>
              </div>
            </article>
          </section>
          <section className="workshops-section workshops-faqs">
            <h2 className="workshops-section-title">¿Tienes dudas?</h2>
            <div className="workshops-faqs-content">
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Necesito tener conocimientos previos para hacer el taller?
                  <IconChevronDown />
                </summary>
                <p>
                  No, el taller está diseñado para cualquier persona interesada en mejorar su
                  relación de pareja.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Puedo ver los videos cuando quiera?
                  <IconChevronDown />
                </summary>
                <p>
                  Sí, podrás acceder a la grabación si no puedes asistir en directo y revisarlo
                  todas las veces que quieras.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Es un taller teórico o práctico?
                  <IconChevronDown />
                </summary>
                <p>
                  Ambos. Combina reflexiones y teoría con ejercicios prácticos que podrás aplicar
                  desde el primer día.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Cuánto dura y en qué formato se imparte?
                  <IconChevronDown />
                </summary>
                <p>
                  Aproximadamente 2h, en formato online. Puedes conectarte desde cualquier lugar.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Necesito algún material especial?
                  <IconChevronDown />
                </summary>
                <p>Solo tu ordenador o móvil con conexión a internet y algo para tomar notas.</p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Quién imparte el taller y qué experiencia tiene?
                  <IconChevronDown />
                </summary>
                <p>
                  Dunia Drexler, psicóloga con amplia experiencia en terapia emocional sistémica y
                  acompañamiento en relaciones de pareja.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Y si mi pareja no quiere hacerlo conmigo?
                  <IconChevronDown />
                </summary>
                <p>
                  No pasa nada, puedes aprovecharlo igualmente a nivel personal. Todo lo que
                  trabajes sobre ti mismo impactará positivamente en tu relación, y quizá incluso
                  motive a tu pareja a sumarse más adelante.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿De verdad se pueden aplicar estos ejercicios en la vida real?
                  <IconChevronDown />
                </summary>
                <p>
                  Sí, están pensados para ser prácticos y fáciles de integrar en el día a día,
                  incluso si tienes poco tiempo. No es teoría abstracta, sino herramientas que
                  puedes poner en marcha desde el primer día.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Qué pasa si ya hemos tenido conflictos graves en la pareja?
                  <IconChevronDown />
                </summary>
                <p>
                  Este taller no sustituye a una terapia de pareja, pero puede ayudarte a entender
                  mejor lo que está pasando y darte claves para recuperar la comunicación y la
                  conexión.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Es útil aunque ahora mismo mi relación esté bien?
                  <IconChevronDown />
                </summary>
                <p>
                  Sí. No hace falta esperar a tener un problema para cuidar tu relación. Este taller
                  te dará herramientas para fortalecer el vínculo y prevenir futuros conflictos.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Es necesario tener pareja para hacer este taller?
                  <IconChevronDown />
                </summary>
                <p>
                  No, no es necesario que tengas una pareja actualmente para poder hacer el taller.
                  Esto puede serte de utilidad para tu crecimiento personal y que podrá beneficiarte
                  para relacionarte de forma más saludable también con tus amigos, familia...
                </p>
              </details>
            </div>
          </section>
          {/* Contacto */}
          <section className="workshops-section workshops-contact">
            <div className="workshops-contact-content">
              <h2 className="workshops-section-title">¿Necesitas un enfoque más personalizado?</h2>
              <p className="workshops-text">
                Si necesitas un acompañamiento más personalizado, podemos ayudarte. Nuestro equipo
                de psicólogos clínicos y nutricionistas está aquí para guiarte y trabajar contigo
                para que puedas gestionar mejor todas las situaciones de la vida.
              </p>
              <Link to="/contacto/" className="workshops-btn workshops-btn-primary">
                Contacta con nosotras
              </Link>
            </div>
          </section>
        </div>
      </main>
    </>
  )
}

export default RelationsPage
